import {
    SOCIETY_GET_VISITORS_LIST,
    SOCIETY_GET_VISITOR_DETAILS,
    SOCIETY_CREATE_VISITOR,
    SOCIETY_UPDATE_VISITOR,
    SOCIETY_DELETE_VISITOR,
    SOCIETY_BLOCK_VISITOR,
    SOCIETY_UNBLOCK_VISITOR,
    SOCIETY_GET_VISITOR_SUMMARY,
} from '../../index.types';

export const getVisitorsList = (data) => ({ type: SOCIETY_GET_VISITORS_LIST, data });
export const getVisitorDetails = (data) => ({ type: SOCIETY_GET_VISITOR_DETAILS, data });
export const createVisitor = (data) => ({ type: SOCIETY_CREATE_VISITOR, data });
export const updateVisitor = (data) => ({ type: SOCIETY_UPDATE_VISITOR, data });
export const deleteVisitor = (data) => ({ type: SOCIETY_DELETE_VISITOR, data });
export const blockVisitor = (data) => ({ type: SOCIETY_BLOCK_VISITOR, data });
export const unblockVisitor = (data) => ({ type: SOCIETY_UNBLOCK_VISITOR, data });
export const getVisitorSummary = (data) => ({ type: SOCIETY_GET_VISITOR_SUMMARY, data });
